import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { ADMIN_API_ENDPOINTS } from "service/apiUrl";
import { API } from "service/Interceptor";

const initialState = {
  subscriptions: [],
  filters: {
    fromDate: "",
    toDate: "",
    subscriptionStatus: "",
    plan: "",
  },
  totalCount: null,
  isSubscriptionsLoading: false,
  isExporting: false,
  hasError: false,
};

export const getAllSubscriptions = createAsyncThunk(
  "get-all-subscriptions",
  async ({ pageSelected, search, filters }) => {


    try {
      const { fromDate, toDate, subscriptionStatus, plan } = filters || {};

      const queryParams = new URLSearchParams({
        search: search || "",
        export: "false",
        pageNo: pageSelected,
        perPage: 10,
      });

      if (fromDate) queryParams.append("fromDate", fromDate);
      if (toDate) queryParams.append("toDate", toDate);
      if (subscriptionStatus) queryParams.append("subscriptionStatus", subscriptionStatus);
      if (plan) queryParams.append("plan", plan);

      const res = await API.get(
        `${ADMIN_API_ENDPOINTS.SUBSCRIPTIONS}?${queryParams.toString()}`
      );

      // const res = await API.get(
      //   `${ADMIN_API_ENDPOINTS.SUBSCRIPTIONS}?search=${
      //     search || ""
      //   }&export=false&pageNo=${pageSelected}&perPage=10`
      // );
      return {
        data: res?.data?.data?.results,
        totalRecord: res?.data?.data?.totalRecord,
      };
    } catch (error) {
      console.log("error", error);
    }
  }
);

export const handleSubscriptionStatus = createAsyncThunk(
  "update-subscription-status",
  async (payload) => {
    try {
      await API.post(ADMIN_API_ENDPOINTS.SUBSCRIPTIONS_STATUS, {
        id: payload?.id,
        status: payload?.status,
        message: payload?.message,
      });
      return {
        id: payload?.id,
        reportMessage: payload.message,
      };
    } catch (error) {
      console.log(error);
    }
  }
);

export const exportSubscriptions = createAsyncThunk(
  "export-subscriptions",
  async () => {
    try {
      const res = await API.get(
        `${ADMIN_API_ENDPOINTS.SUBSCRIPTIONS}?export=true`,
        {
          responseType: "blob",
        }
      );
      return res;
    } catch (error) {
      console.log("error", error);
    }
  }
);

const subsciptionSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      //-----------GET ALL SUBSCRIPTIONS--------------------------
      .addCase(getAllSubscriptions.pending, (state, action) => {
        state.isSubscriptionsLoading = true;
      })
      .addCase(getAllSubscriptions.rejected, (state, action) => {
        state.isSubscriptionsLoading = false;
      })
      .addCase(getAllSubscriptions.fulfilled, (state, action) => {
        state.isSubscriptionsLoading = false;
        state.subscriptions = action.payload?.data;
        state.totalCount = action.payload?.totalRecord;
      })
      //------------------TOGGLE STATUS------------------------
      .addCase(handleSubscriptionStatus.fulfilled, (state, action) => {
        const index = state.subscriptions.findIndex(
          (row) => row.id === action.payload?.id
        );

        state.subscriptions[index].subscriptionStatus =
          !state.subscriptions[index].subscriptionStatus;
        state.subscriptions[index].message = action.payload?.reportMessage;
      })
      //--------------------EXPORT SUBSCRIPTIONS--------------------
      .addCase(exportSubscriptions.pending, (state, action) => {
        state.isExporting = true;
      })
      .addMatcher(
        isAnyOf(exportSubscriptions.fulfilled, exportSubscriptions.rejected),
        (state) => {
          state.isExporting = false;
        }
      );
  },
});

export const { setFilters } = subsciptionSlice.actions;
export default subsciptionSlice.reducer;
